export const ESTAGIO_DO_CONVIDADO_LABELS = {
    sem_adega: 'Entrou, sem adega',
    adega_vazia: 'Adega criada, sem garrafa',
    em_uso: 'Usando',
    conta_apagada: 'Conta apagada',
};
//# sourceMappingURL=types.js.map